import { Button, TextField, Typography } from '@mui/material';
import { DialogContainerComponent } from '../../layout/dialogContainer.component';
import { END_RENTAL_FAILURE, END_RENTAL_SUCCESS, endRental } from '../location.actions';
import { handleToastMessage } from '../../layout/layout.actions';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

export const EndRentalDialog = ({ selectedLocation, isOpen, onClose, onSubmit }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const setError = (field, error) => {
    setErrors(errors => ({ ...errors, [field]: error }));
    setIsSubmitDisabled(true);
  };
  const clearErrors = () => {
    setErrors({});
    setIsSubmitDisabled(false);
  };

  const handleConfirmPodSerialChange = e => {
    const value = e.target.value;
    if (!value) {
      setError('confirmPodSerial', 'Pod serial is required');
    } else if (value !== selectedLocation.podDeviceSerial) {
      setError('confirmPodSerial', 'Pod serial does not match');
    } else {
      clearErrors();
    }
  };

  return (
    <DialogContainerComponent
      isOpen={isOpen}
      isSubmitDisabled={isSubmitDisabled}
      onClose={onClose}
      onSubmit={onSubmit}
      title="Are you sure you want to end this rental?"
    >
      <Typography variant="subtitle1">
        Please type in the pod serial number <strong>{selectedLocation.podDeviceSerial}</strong> to confirm.
      </Typography>
      <TextField
        style={{marginTop: 10, marginBottom: 5}}
        label="Pod Serial Number"
        fullWidth
        onChange={handleConfirmPodSerialChange}
        variant="outlined"
        helperText={errors.confirmPodSerial ? errors.confirmPodSerial : undefined}
        error={Boolean(errors.confirmPodSerial)}
      />
    </DialogContainerComponent>
  );
};

EndRentalDialog.propTypes = {
  selectedLocation: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export const EndRental = ({ className, disabled, selectedLocation, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dialog = {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
  const dispatch = useDispatch();

  const handleEndRental = async () => {
    const { type, messages } = await dispatch(endRental(selectedLocation.id));
    if (type === END_RENTAL_SUCCESS) {
      dispatch(handleToastMessage('Rental ended successfully'));
      onSuccess();
    } else if (type === END_RENTAL_FAILURE) {
      let errorMessage = 'Failed to end rental';
      if (messages && messages.length) {
        errorMessage = `${errorMessage}: ${messages.join(',')}`;
      }
      dispatch(handleToastMessage(errorMessage, true));
    }
    dialog.close();
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        className={className}
        onClick={dialog.open}
        disabled={disabled}
      >
        End Rental
      </Button>
      <EndRentalDialog
        selectedLocation={selectedLocation}
        isOpen={dialog.isOpen}
        onClose={dialog.close}
        onSubmit={handleEndRental}
      />
    </>
  );
};

EndRental.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  selectedLocation: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
